import { YL, TX2 } from "../utils/constants";

export default function AlertsBanner({ firedAlerts, onDismiss }) {
  if (!firedAlerts.length) return null;
  return (
    <>
      {firedAlerts.map((a, i) => (
        <div key={i} style={{ background: YL + "10", border: `1px solid ${YL}30`, borderRadius: 6, padding: "6px 12px", marginBottom: 6, fontSize: 9, color: YL, display: "flex", justifyContent: "space-between" }}>
          {a} <span style={{ cursor: "pointer", color: TX2 }} onClick={() => onDismiss(i)}>✕</span>
        </div>
      ))}
    </>
  );
}
